module.exports = __webpack_public_path__ + "static/media/Icon_menu_cleaning_products_white.67d08a3f.svg";